import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const AloneListenIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 68,
  height = 34,
  ...rest
}) => {
  return (
    <Icon
      data-testid="needs-based-filter-icon-aloneListen"
      fill={fill}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      {...rest}
    >
      <g fill="none" fillRule="evenodd">
        <polygon fill="#ffffff" className={styles.white} opacity="0" points="0 34 68 34 68 0 0 0" />
        <path
          d="M34,7 C29.5817153,7 26,10.5817153 26,15 C26,19.4182847 29.5817153,23 34,23 C38.4182847,23 42,19.4182847 42,15 C42,10.5817153 38.4182847,7 34,7 Z M34,9 C37.3137153,9 40,11.6862847 40,15 C40,18.3137153 37.3137153,21 34,21 C30.6862847,21 28,18.3137153 28,15 C28,11.6862847 30.6862847,9 34,9 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <path
          d="M32 12C33.0539541 12 33.9181281 12.816267 33.9945117 13.8507907L34 14 33 14C33 13.4481424 32.5518576 13 32 13 31.4875608 13 31.0645495 13.3864085 31.0067338 13.8834578L31 14 30 14C30 12.8958576 30.8958576 12 32 12ZM36 12C37.0539541 12 37.9181281 12.816267 37.9945117 13.8507907L38 14 37 14C37 13.4481424 36.5518576 13 36 13 35.4875608 13 35.0645495 13.3864085 35.0067338 13.8834578L35 14 34 14C34 12.8958576 34.8958576 12 36 12ZM34 15C35.1041424 15 36 15.8958576 36 17 36 18.0539541 35.183733 18.9181281 34.1492093 18.9945117L34 19 34 18C34.5518576 18 35 17.5518576 35 17 35 16.4875608 34.6135915 16.0645495 34.1165422 16.0067338L34 16 34 15ZM34 21C38.3349209 21 41.8645431 24.4478313 41.9961932 28.7508203L42 29 40 29C40 25.6862847 37.3137153 23 34 23 30.7615965 23 28.1224279 25.5655684 28.0041385 28.7750613L28 29 26 29C26 24.5817153 29.5817153 21 34 21Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <path
          d="M19.7071,21.2929 C17.5241,19.4579 16.0001,16.9109 16.0001,13.9999 C16.0001,11.0889 17.5241,8.5429 19.7071,6.7069 C20.6931,5.8779 19.2721,4.4689 18.2931,5.2929 C15.7201,7.4569 14.0001,10.5929 14.0001,13.9999 C14.0001,17.4069 15.7201,20.5429 18.2931,22.7069 C19.2721,23.5309 20.6941,22.1229 19.7071,21.2929"
          fill="#0050B3"
          className={styles.interactiveColor}
        />
        <path
          d="M21.7071 17.2929C21.1221 16.7989 20.7261 16.3459 20.3881 15.6729 20.1391 15.1769 20.0001 14.5659 20.0001 13.9999 20.0001 13.8449 20.0091 13.6899 20.0231 13.5349 20.0311 13.4639 20.0301 13.4659 20.0201 13.5439L20.0371 13.4409C20.0541 13.3559 20.0701 13.2699 20.0891 13.1859 20.1681 12.8469 20.2571 12.5939 20.3631 12.3759 20.7041 11.6799 21.1081 11.2129 21.7071 10.7069 22.1201 10.3589 22.0661 9.6519 21.7071 9.2929 21.2981 8.8839 20.7071 8.9429 20.2931 9.2929 18.9111 10.4599 18.0001 12.1699 18.0001 13.9999 18.0001 15.8299 18.9111 17.5399 20.2931 18.7069 20.7051 19.0549 21.3031 19.1119 21.7071 18.7069 22.0641 18.3499 22.1221 17.6429 21.7071 17.2929M49.7071 22.7071C52.2801 20.5431 54.0001 17.4071 54.0001 14.0001 54.0001 10.5931 52.2801 7.4571 49.7071 5.2931 48.7281 4.4691 47.3061 5.8771 48.2931 6.7071 50.4751 8.5421 52.0001 11.0891 52.0001 14.0001 52.0001 16.9111 50.4751 19.4571 48.2931 21.2931 47.3071 22.1221 48.7281 23.5311 49.7071 22.7071"
          fill="#0050B3"
          className={styles.interactiveColor}
        />
        <path
          d="M47.7071,18.7071 C49.0891,17.5401 50.0001,15.8301 50.0001,14.0001 C50.0001,12.1701 49.0891,10.4601 47.7071,9.2931 C47.2951,8.9451 46.6971,8.8881 46.2931,9.2931 C45.9351,9.6501 45.8781,10.3571 46.2931,10.7071 C46.8781,11.2011 47.2731,11.6541 47.6121,12.3271 C47.8611,12.8231 48.0001,13.4341 48.0001,14.0001 C48.0001,14.1551 47.9901,14.3101 47.9771,14.4651 C47.9691,14.5361 47.9701,14.5341 47.9801,14.4561 L47.9631,14.5591 C47.9461,14.6441 47.9301,14.7301 47.9101,14.8141 C47.8311,15.1531 47.7431,15.4061 47.6361,15.6241 C47.2961,16.3201 46.8921,16.7871 46.2931,17.2931 C45.8801,17.6411 45.9341,18.3481 46.2931,18.7071 C46.7021,19.1161 47.2931,19.0571 47.7071,18.7071"
          fill="#0050B3"
          className={styles.interactiveColor}
        />
      </g>
    </Icon>
  )
}
